import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { stage } from "../../assets/globalHelpers";
import "../../assets/css/argon-dashboard-react.css"
import { Col } from "reactstrap"
import { stagesNames } from "../translation.js"
import { useLanguage } from "context/LanguageProvider";
import { useEffect } from "react";
import { useDarkMode } from "context/DarkModeProvider";
import axiosInstance from "apiHandles/axiosInstance"; // ✅ Πρόσθεσε

function StackDiagram({ items, finalStages, onItemClick }) {
  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { darkMode } = useDarkMode();
  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  const colorScheme = {
    primary: '#f59e0b',
    secondary: '#d97706',
    accent: '#fef3c7'
  };

  const handleItemClick = (index) => {
    if (onItemClick) {
      onItemClick(index);
      return;
    }

    const stage = finalStages[index];
    if (!stage) {
      console.error("No stage found at index:", index);
      return;
    }

    // ✅ Αποθηκεύουμε ΜΟΝΟ το ID
    localStorage.setItem("stageLocation", stage.name);
    localStorage.setItem("selectedStageId", stage.id);  // ✅ Μόνο ID

    navigate("/admin/index");
  };

  const reversedItems = [...items].reverse();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "70vh",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Ετικέτα "TOP" στην κορυφή της στοίβας */}
        <div
          style={{
            fontWeight: "bold",
            fontSize: "18px",
            color: darkMode ? "var(--commonWhite)" : colorScheme.primary,
          }}
        >
          TOP
        </div>

        {/* Στοιχεία της στοίβας */}
        {reversedItems.map((item, reverseIndex) => {
          const originalIndex = items.length - 1 - reverseIndex;

          return (
            <div
              key={originalIndex}
              style={{
                width: "90%",
                textAlign: "center",
                borderRadius: "12px",
                background: `linear-gradient(135deg, ${colorScheme.primary}15 0%, ${colorScheme.secondary}10 100%)`,
                backdropFilter: 'blur(10px)',
                border: `1px solid ${colorScheme.primary}30`,
                color: colorScheme.primary,
                padding: "20px 10px",
                margin: "3px 0",
                cursor: "pointer",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                transform: hoveredIndex === originalIndex ? "scale(1.05) translateY(-4px)" : "scale(1) translateY(0)",
                boxShadow: hoveredIndex === originalIndex
                  ? `0 0px 10px ${colorScheme.primary}40, 0 0 0 1px ${colorScheme.primary}20`
                  : `none`,
                zIndex: items.length - reverseIndex,
              }}
              onMouseEnter={() => setHoveredIndex(originalIndex)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => handleItemClick(originalIndex)}
            >
              {/* Animated background overlay για hover effect */}
              <div
                style={{
                  position: 'absolute',
                  inset: '0',
                  background: `linear-gradient(135deg, ${colorScheme.primary}${hoveredIndex === originalIndex ? '25' : '15'} 0%, ${colorScheme.secondary}${hoveredIndex === originalIndex ? '20' : '10'} 100%)`,
                  transition: 'all 0.3s ease',
                  borderRadius: '12px',
                }}
              />

              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  position: 'relative',
                  zIndex: 1,
                  background: `linear-gradient(135deg, ${colorScheme.primary} 0%, ${colorScheme.secondary} 100%)`,
                  WebkitBackgroundClip: 'text',
                  color: darkMode ? "var(--commonWhite)" : colorScheme.primary,
                  backgroundClip: 'text',
                }}
              >
                {selLanguage ? stagesNames[item.toLowerCase()] : item}
              </div>

              {/* Ετικέτα με το index στα δεξιά */}
              <div
                style={{
                  position: "absolute",
                  right: "-50px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: darkMode ? "var(--commonWhite)" : colorScheme.primary,
                  fontWeight: hoveredIndex === originalIndex ? "bold" : "600",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                }}
              >
                [{originalIndex}]
              </div>
            </div>
          );
        })}

        {/* Βάση της στοίβας */}
        <div
          style={{
            width: "240px",
            height: "12px",
            background: `linear-gradient(135deg, ${colorScheme.primary}20 0%, ${colorScheme.secondary}15 100%)`,
            borderRadius: "0 0 8px 8px",
            marginTop: "2px",
            border: `1px solid ${colorScheme.primary}30`,
            borderTop: 'none',
          }}
        ></div>
      </div>
    </div>
  );
}

export default StackDiagram;